import { TranslateService } from '@ngx-translate/core';

export function appInitializer(translate: TranslateService) {
  return () => {
    translate.setDefaultLang('en');
    translate.use('en');
  };
}
